function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const listItemAvatarStyles = process.env.NODE_ENV === "production" ? {
  name: "9q39xd",
  styles: "min-width:32px"
} : {
  name: "39npw7-listItemAvatarStyles",
  styles: "min-width:32px;label:listItemAvatarStyles;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL2NpcmNsZWNpL3Byb2plY3QvYXNjZW5kL3NyYy9jb21wb25lbnRzL0xpc3RJdGVtQXZhdGFyL0xpc3RJdGVtQXZhdGFyLnN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFdUMiLCJmaWxlIjoiL2hvbWUvY2lyY2xlY2kvcHJvamVjdC9hc2NlbmQvc3JjL2NvbXBvbmVudHMvTGlzdEl0ZW1BdmF0YXIvTGlzdEl0ZW1BdmF0YXIuc3R5bGVzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuXG5leHBvcnQgY29uc3QgbGlzdEl0ZW1BdmF0YXJTdHlsZXMgPSBjc3NgXG4gIG1pbi13aWR0aDogMzJweDtcbmA7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export {
  listItemAvatarStyles
};
//# sourceMappingURL=ListItemAvatar.styles.js.map
